module.exports = "<div class=\"modal-content report-modal\">\n    <div class=\"modal-header ng-scope\">\n      <h3 class=\"modal-title\" id=\"modal-title\">{{ $ctrl.message }}</h3>\n    </div>\n    <div class=\"modal-footer ng-scope\">\n      <button class=\"btn button-plain\" ng-click=\"$ctrl.ok(form)\">OK</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/notification-modal.html
// module id = 645
// module chunks = 0